import { JSX } from 'solid-js';

export const Button = (props: {
  disabled?: boolean;
  onClick: () => void;
  children: string | JSX.Element;
  startIcon?: JSX.Element;
  endIcon?: JSX.Element;
}) => {
  return (
    <button
      class="bg-armstrong-primary cursor-pointer text-white px-2 py-1 rounded-md font-normal text-sm disabled:opacity-20 disabled:pointer-events-none inline-flex items-center gap-1"
      disabled={props.disabled ?? false}
      onClick={props.onClick}
    >
      {props.startIcon}
      {props.children}
      {props.endIcon}
    </button>
  );
};
